module.exports = __webpack_public_path__ + "media/images/talent/case01-illust-71402088795785fb2a5170a2a88eb285.png";